import { globalModule } from "../service-provider/GlobalModule";
import { registerGlobalService } from "../service-provider/ServiceRegistry";

export interface Browser {
  language: string;
  hostname: string;
  refresh: () => void;
}

export class BrowserService implements Browser {
  language: string;
  hostname: string;

  constructor() {
    this.language = window.navigator.language.slice(0, 2);
    this.hostname = window.location.hostname; 
  }

  public refresh() {
    setTimeout(() => {
      window.location.reload();
    }, 0);
  }
}

export const browser = new BrowserService();
globalModule.browser = browser;
export default registerGlobalService(browser as Browser);
